import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ACCOUNTING_INCOME_STATEMENT_BASE_PATH } from '../../../../../../../../../features/accounting/income-statement/accounting-income-statement-routing';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/income-statement/_income-statement',
)({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'income-statement',
        label: 'Accounting',
        to: ACCOUNTING_INCOME_STATEMENT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
